import Controller from "@ember/controller"
import { action, get } from "@ember/object"
import { inject as service } from "@ember/service"

export default class ImpersonateController extends Controller {
  @service("ember-store")
  store

  @service
  rpc

  @service
  session

  impersonatingEmail = null
  impersonatingUserId = null

  @action
  stopImpersonating() {
    get(this, "session").stopImpersonating()
    window.location.reload()
  }

  @action
  startImpersonatingByEmail() {
    get(this, "rpc")
      .execute("IMPERSONATE_BY_EMAIL", {
        email: get(this, "impersonatingEmail"),
      })
      .then((data) => {
        let userId = get(this, "session").impersonate(data.userId, data.token)
        window.location.reload()
      })
  }

  @action
  startImpersonatingByUserId() {
    get(this, "session").impersonateUserId(
      get(this, "impersonatingUserId"),
      `${window.location.origin}/users/${get(this, "impersonatingUserId")}`
    )
  }
}
